export default {
  namespaced: true,
  state: {
    items: {
      0: [],
      1: [],
      2: [],
    } as { [serverIndex in number]: any[] },
  },
  getters: {
    getItems: (state: any) => state.items || [],
  },
  mutations: {
    APPLY_FILTER: (state: any, payload: any) => (state.filter = payload),
    SET_ITEMS: (state: any, payload: { items: any[]; serverIndex: number }) => (state.items[payload.serverIndex] = payload.items),
  },
  actions: {},
};
